import { HandleVisibilityChange } from "../../../../../src/demos/handle-visibility-change.tsx";
import * as React from 'react';
export default {
  HandleVisibilityChange,
  React
};